module.exports = __webpack_public_path__ + "img/maine-et-loire.11462fe8.svg";